<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteTable = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="ira_location_name">{{ $t('ira_location_name') }}</label>
                            <InputText
                                id="ira_location_name"
                                type="text"
                                v-model="location_name"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                            />
                        </div>
                        <div class="p-grid p-col">
                            <div class="p-field p-col-12 p-lg-8 p-mt-3">
                                <label for="ira_disaster">{{ $t('disaster_type') }}</label>
                                <Dropdown
                                    v-model="disasterSelect"
                                    :options="disasterOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterOptions">
                                        <div v-if="disasterOptions.value">
                                            <div>{{ disasterOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterOptions">
                                        <div class="EV_disasterOptions">{{ disasterOptions.option.system_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <div class="p-field p-col-12 p-lg-4 p-mt-3">
                                <label for="riskLevelSelected">{{ $t('disaster_level') }}</label>
                                <Dropdown
                                    :disabled="isriskLevel == 1"
                                    v-model="riskLevelSelected"
                                    :options="riskLevelOptions"
                                    optionLabel="risklevel_number"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :filter="true"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="riskLevelOptions">
                                        <div v-if="riskLevelOptions.value">
                                            <div>{{ riskLevelOptions.value.risklevel_number }}</div>
                                        </div>
                                        <span v-else>
                                            {{ riskLevelOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="riskLevelOptions">
                                        <div>{{ riskLevelOptions.option.risklevel_number }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>
                        <!-- <div class="p-field p-col-8 p-lg-3 p-mt-2">
              <label for="ira_organize">{{ $t("response_agency") }}</label>
              <InputText
                id="ira_organize"
                type="text"
                v-model="selectedOrganize.name"
                disabled
              />
            </div>
            <div class="p-field  p-lg-1" style="padding-top: 3.5px ;" >
              <div class="p-formgrid p-grid p-jc-start">
                <Button
                  @click="showOrganize = true"
                  icon="pi pi-ellipsis-h"
                  class="p-button-secondary p-mt-5 p-mr-2"
                />
                <Button
                  @click="selectedOrganize = {}"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-5"
                />
              </div>
            </div> -->

                        <div class="p-formgrid p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="selectedProvince"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="selectedAmphur"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="selectedTambon"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                            <!-- <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label for="riskLevelSelected">{{ $t("disaster_level") }}</label>
                <Dropdown
                  :disabled="isriskLevel == 1"
                  v-model="riskLevelSelected"
                  :options="riskLevelOptions"
                  optionLabel="risklevel_number"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  :showClear="true"
                >
                  <template #value="riskLevelOptions">
                    <div v-if="riskLevelOptions.value">
                      <div>{{ riskLevelOptions.value.risklevel_number }}</div>
                    </div>
                    <span v-else>
                      {{ riskLevelOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="riskLevelOptions">
                    <div>{{ riskLevelOptions.option.risklevel_number }}</div>
                  </template>
                </Dropdown>
              </div> -->
                            <div class="p-field p-col">
                                <div class="p-formgrid p-grid p-jc-end p-mt-5">
                                    <!-- Doe โหลด โทรศัพท์ -->
                                    <Button
                                        v-if="window.width <= 430"
                                        @click="MobileClearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_3_search"
                                        @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                    <Button
                                        v-else
                                        @click="clearSearchField()"
                                        :label="$t('clearBtn')"
                                        class="p-button-clear p-ml-3 p-mr-3"
                                        ref="TextBox_3_search"
                                        @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                    <!-- Doe โหลด โทรศัพท์ -->
                                    <Button
                                        @click="searchRiskArea()"
                                        :label="$t('searchBtn')"
                                        class="p-button-info"
                                        ref="TextBox_4_search"
                                        @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="riskArea_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? riskArea_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                :sortOrder="1"
                sortField="index"
                dataKey="riskarea_id"
                ref="dt"
                :exportFilename="`ข้อมูลพื้นที่เสี่ยงภัย-${date}`"
                :rowHover="true"
                :selection.sync="selectedRiskArea"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid p-col">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="riskAreaModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedRiskArea && selectedRiskArea.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedRiskArea.length === riskArea_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedRiskArea.some((item) => item.riskarea_id === slotProps.data.riskarea_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_riskarea_name == true">
                    <Column
                        field="riskarea_name"
                        :header="$t('ira_location_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_riskarea_name == true">
                                {{ dataTable.data.riskarea_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_organize_name == true">
                    <Column
                        field="organize_name"
                        :header="$t('response_agency')"
                        :sortable="true"
                        :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_organize_name == true">
                                {{ dataTable.data.organize_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_system_name == true">
                    <Column
                        field="system_name"
                        :header="$t('disaster_type')"
                        :sortable="true"
                        :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_system_name == true">
                                {{ dataTable.data.system_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_disaster_level == true">
                    <Column
                        field="disaster_level"
                        :header="$t('disaster_level')"
                        :sortable="true"
                        :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_disaster_level == true">
                                <div v-if="dataTable.data.disaster_level == '1'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#00902A',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.disaster_level }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.disaster_level == '2'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#92D14F',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.disaster_level }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.disaster_level == '3'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FCFC25',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.disaster_level }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.disaster_level == '4'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FE7B00',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.disaster_level }}
                                    </div>
                                </div>
                                <div v-else-if="dataTable.data.disaster_level == '5'" class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#FE0000',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.disaster_level }}
                                    </div>
                                </div>
                                <div v-else class="table_row">
                                    <div
                                        :style="{
                                            color: '#fff',
                                            backgroundColor: '#A09B9B',
                                            display: 'inline-flex',
                                            padding: '5px',
                                            paddingLeft: '15px',
                                            paddingRight: '15px',
                                            color: '#002678',
                                            fontWeight: 'bolder',
                                            borderRadius: '10px'
                                        }"
                                    >
                                        {{ dataTable.data.disaster_level }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_riskarea_location == true">
                    <Column
                        field="riskarea_location"
                        :header="$t('location')"
                        :sortable="true"
                        :headerStyle="tableColSticky('30rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_riskarea_location == true">
                                <div v-if="dataTable.data.riskarea_location == ''">-</div>
                                <div v-else>{{ dataTable.data.riskarea_location }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_riskarea_lat == true">
                    <Column
                        field="riskarea_lat"
                        :header="`ละติจูด`"
                        :sortable="true"
                        :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_riskarea_lat == true">
                                {{ parseFloat(dataTable.data.riskarea_lat).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_riskarea_lon == true">
                    <Column
                        field="riskarea_lon"
                        :header="`ลองจิจูด`"
                        :sortable="true"
                        :headerStyle="tableColSticky('10rem', 'center', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_riskarea_lon == true">
                                {{ parseFloat(dataTable.data.riskarea_lon).toFixed(6) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_riskarea_lon ||
                        columns_index ||
                        columns_riskarea_name ||
                        columns_organize_name ||
                        columns_system_name ||
                        columns_disaster_level ||
                        columns_riskarea_location ||
                        columns_riskarea_lat ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <!-- checkNotAdminPermission เอาไว้เช็คว่าต้องเป็น User ตัวเองเท่านั้นถึงแก้ได้ ในกรณีที่ไม่ใช่ Admin System  -->
                            <!-- <div class="p-formgrid p-grid" v-if="checkNotAdminPermission(dataTable.data.user_organize)"> -->
                            <!-- แก้ใหม่ให้เปิดให้แก้ไขได้ -->
                            <div class="p-formgrid col_manege">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            riskAreaModal = true;
                                            editData(dataTable.data.riskarea_id);
                                            temp = dataTable.data.riskarea_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.riskarea_id;
                                            deleteTable = '';
                                            alertDisplay(temp, deleteTable);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        <!-- v-if="loadingCreate" -->
        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="riskAreaModal"
            :style="{ width: '80%' }"
            :contentStyle="{}"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" style="top: 40%" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('ira_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-6 p-mt-2" style="margin-top: -5px">
                            <label for="ira_location_name">{{ $t('ira_location_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="ira_location_name"
                                type="text"
                                v-model="ira_location_name"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_ira_location_name && !ira_location_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_ira_location_name && !ira_location_name">{{
                                $t('ira_location_name_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col-8 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="ira_selectedOrganize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                            <InputText
                                id="ira_selectedOrganize"
                                type="text"
                                v-model="ira_selectedOrganize.name"
                                disabled
                                :class="{
                                    'p-invalid': error_ira_selectedOrganize && !ira_selectedOrganize.name
                                }"
                            />
                            <small class="p-invalid" v-if="error_ira_selectedOrganize && !ira_selectedOrganize.name">{{
                                $t('iie_organize_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-lg-2">
                            <div>
                                <Button
                                    @click="showOrganize_Form = true"
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mt-5 p-mr-2"
                                    ref="TextBox_2"
                                    @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                                />
                                <Button
                                    @click="ira_selectedOrganize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                    ref="TextBox_3"
                                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <label for="ira_location_detail">{{ $t('location') }}</label>
                            <InputText
                                id="ira_location_detail"
                                type="text"
                                v-model="ira_location_detail"
                                required="true"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_5', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="provinceOptions">{{ $t('province') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ira_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedProvince && !ira_selectedProvince
                                }"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedProvince && !ira_selectedProvince">กรุณาระบุจังหวัด</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="amphurOptions">{{ $t('amphur') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledAmphur == 1"
                                @input="inputMap_PAT_latlon"
                                v-model="ira_selectedAmphur"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedAmphur && ira_selectedAmphur == null
                                }"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedAmphur && ira_selectedAmphur == null">กรุณาระบุเขต/อำเภอ</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="tambonOptions">{{ $t('tambon') }} <span class="required-input">*</span></label>
                            <Dropdown
                                :disabled="ira_isDisabledTambon == 1"
                                v-model="ira_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                                :class="{
                                    'p-invalid': error_ira_selectedTambon && ira_selectedTambon == null
                                }"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedTambon && ira_selectedTambon == null">กรุณาระบุแขวง/ตำบล </small>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-5 p-mt-2" style="margin-top: -5px">
                            <label for="ira_disasterTypeSelected">{{ $t('disaster_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ira_disasterTypeSelected"
                                :options="disasterOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :class="{
                                    'p-invalid': error_ira_selectedDisaster && !ira_disasterTypeSelected
                                }"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterOptions">
                                    <div v-if="disasterOptions.value">
                                        <div>{{ disasterOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ disasterOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="disasterOptions">
                                    <div class="EV_disasterOptions">{{ disasterOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ira_selectedDisaster && !ira_disasterTypeSelected">{{
                                $t('selectedDisaster_validate')
                            }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-3 p-mt-2">
                            <label for="ira_riskLevelSelected">{{ $t('disaster_level') }}<span class="required-input"></span></label>
                            <Dropdown
                                :disabled="ira_isriskLevel == 1"
                                v-model="ira_riskLevelSelected"
                                :options="riskLevelOptions"
                                optionLabel="risklevel_number"
                                :placeholder="$t('placeholderSelectBox')"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="riskLevelOptions">
                                    <div v-if="riskLevelOptions.value">
                                        <div>{{ riskLevelOptions.value.risklevel_number }}</div>
                                    </div>
                                    <span v-else>
                                        {{ riskLevelOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="riskLevelOptions">
                                    <div>{{ riskLevelOptions.option.risklevel_number }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2 p-mt-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ira_lat">{{ $t('lat') }}</label>
                            <InputText
                                id="ira_lat"
                                type="text"
                                v-model="ira_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_5"
                                @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ira_lon">{{ $t('lon') }}</label>
                            <InputText
                                id="ira_lon"
                                type="text"
                                v-model="ira_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_6"
                                @keyup.left="moveFocus($event, 'TextBox_5', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_7', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(ira_lat, ira_lon);
                                    sendM_PAT(ira_selectedTambon, ira_selectedAmphur, ira_selectedProvince);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_8', 'Button')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_8"
                    @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_9', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_8"
                    @keyup.left="moveFocus($event, 'TextBox_7', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_9', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_9"
                    @keyup.left="moveFocus($event, 'TextBox_8', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_5', 'Input')"
                />
            </template>
            <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" autofocus />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-risk-area',
    components: {
        organizeTable,
        organizeForm,
        mapArea,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            riskArea_Table: [],
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,

            filters: {},
            temp: null,
            showOrganize: false,
            showOrganize_Form: false,
            selectedRiskArea: [],
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            deleteTable: '',
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],
            disasterSelect: null,
            isriskLevel: 1,

            riskLevelOptions: [],
            riskLevelSelected: null,

            header: this.$i18n.t('ira_modal_title_add'),
            selectedData: '',

            riskAreaModal: false,
            ira_location_name: '',
            ira_location_detail: '',
            ira_selectedOrganize: {},
            ira_selectedProvince: null,
            ira_selectedAmphur: null,
            ira_selectedTambon: null,
            ira_isDisabledAmphur: 1,
            ira_isDisabledTambon: 1,
            ira_isriskLevel: 1,
            ira_disasterTypeSelected: null,
            ira_riskLevelSelected: null,
            ira_lat: '',
            ira_lon: '',

            error_ira_selectedProvince: false,
            error_ira_selectedAmphur: false,
            error_ira_selectedTambon: false,
            error_ira_selectedOrganize: false,
            error_ira_location_name: false,
            error_ira_selectedDisaster: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            date_create_form: '',
            date_update_form: '',

            // เพิ่ม มุดmap 3/4
            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            // เพิ่ม มุดmap 3/4 จบ

            loading: false,

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อพื้นที่',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสาธารณภัย',
                    textShow: ''
                },
                {
                    DataName: 'ระดับ',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลพื้นที่เสี่ยงภัย',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 11,
            PDF_FontBodyVer: 8,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 28 },
                disaster_level: { cellWidth: 26 },
                organize_name: { cellWidth: 80 },
                system_name: { cellWidth: 70 },

                riskarea_latPDF: { cellWidth: 40 },
                riskarea_lonPDF: { cellWidth: 40 }
            },

            PDF_minCellWidthHor: 80,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 10,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 },
                disaster_level: { cellWidth: 35 },
                organize_name: { cellWidth: 90 },
                system_name: { cellWidth: 100 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อพื้นที่', dataKey: 'riskarea_name' },
                { title: 'หน่วยงานที่รับผิดชอบ', dataKey: 'organize_name' },
                { title: 'ประเภทสาธารณภัย', dataKey: 'system_name' },
                { title: 'ระดับ', dataKey: 'disaster_level' },
                { title: 'ที่ตั้ง', dataKey: 'riskarea_location' },
                { title: 'ละติจูด', dataKey: 'riskarea_latPDF' },
                { title: 'ลองจิจูด', dataKey: 'riskarea_lonPDF' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_riskarea_name: true,
            columns_organize_name: true,
            columns_system_name: true,
            columns_disaster_level: true,
            columns_riskarea_location: true,
            columns_riskarea_lat: true,
            columns_riskarea_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index', 'riskarea_latPDF', 'riskarea_lonPDF'];

                        const fill_row_detail = [
                            {
                                name_row: 'disaster_level',
                                detail_row: [
                                    {
                                        check_text: '1',
                                        fill_color: [0, 144, 42]
                                    },
                                    {
                                        check_text: '2',
                                        fill_color: [146, 209, 79]
                                    },
                                    {
                                        check_text: '3',
                                        fill_color: [252, 252, 37]
                                    },
                                    {
                                        check_text: '4',
                                        fill_color: [254, 123, 0]
                                    },
                                    {
                                        check_text: '5',
                                        fill_color: [254, 0, 0]
                                    }
                                ]
                            }
                        ];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor,
                            //
                            check_fill_row: true,
                            fill_row_detail: fill_row_detail
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index', 'riskarea_latPDF', 'riskarea_lonPDF'];

                        const fill_row_detail = [
                            {
                                name_row: 'disaster_level',
                                detail_row: [
                                    {
                                        check_text: '1',
                                        fill_color: [0, 144, 42]
                                    },
                                    {
                                        check_text: '2',
                                        fill_color: [146, 209, 79]
                                    },
                                    {
                                        check_text: '3',
                                        fill_color: [252, 252, 37]
                                    },
                                    {
                                        check_text: '4',
                                        fill_color: [254, 123, 0]
                                    },
                                    {
                                        check_text: '5',
                                        fill_color: [254, 0, 0]
                                    }
                                ]
                            }
                        ];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor,
                            //
                            check_fill_row: true,
                            fill_row_detail: fill_row_detail
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async riskAreaModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.ira_location_name != null &&
                    this.ira_selectedOrganize.name != undefined &&
                    this.ira_disasterTypeSelected != null
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.riskAreaModal = false;
                            this.clearData();
                        } else {
                            this.riskAreaModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/risklevel`, {
                            body: { topic: 'get-level-option' }
                        })
                        .then((response) => {
                            (this.riskLevelOptions = response.data.data),
                                this.riskLevelOptions.splice(0, 0, {
                                    risklevel_number: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterOptions = response.data.data),
                                this.disasterOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });

                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.ira_selectedOrganize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterOptions = response.data.data;
                    });

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-province'
                        }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.riskAreaModal = true;
            }
        },

        async disasterSelect(val) {
            this.riskLevelSelected = null;
            if (val != null) {
                this.isriskLevel = 0;
                await this.axios
                    .post(`${this.$url_service}/initial/risklevel`, {
                        body: { topic: 'get-level-option-disaster', id: val.system_id }
                    })
                    .then((response) => {
                        (this.riskLevelOptions = response.data.data),
                            this.riskLevelOptions.splice(0, 0, {
                                risklevel_number: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isriskLevel = 1;
                this.riskLevelSelected = null;
            }
        },

        async ira_disasterTypeSelected(val) {
            this.ira_riskLevelSelected = null;
            if (val != null) {
                this.ira_isriskLevel = 0;
                await this.axios
                    .post(`${this.$url_service}/initial/risklevel`, {
                        body: { topic: 'get-level-option-disaster', id: val.system_id }
                    })
                    .then((response) => (this.riskLevelOptions = response.data.data));
            } else {
                this.ira_isriskLevel = 1;
                this.ira_riskLevelSelected = null;
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.disaster_level == 'null') {
                    this.ira_riskLevelSelected = null;
                } else {
                    this.ira_riskLevelSelected = { risklevel_number: val.disaster_level };
                }

                if (val.location_id == 'null') {
                    this.ira_selectedProvince = null;
                    this.ira_selectedAmphur = null;
                    this.ira_selectedTambon = null;
                } else {
                    this.ira_selectedProvince = {
                        province_id: val.province_id,
                        province_name: val.province_name
                    };
                    this.ira_selectedAmphur = {
                        amphur_id: val.amphur_id,
                        amphur_name: val.amphur_name
                    };
                    this.ira_selectedTambon = {
                        tambon_id: val.location_id,
                        tambon_name: val.tambon_name
                    };
                }
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async ira_selectedProvince(val) {
            if (val != null) {
                this.ira_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.ira_selectedProvince.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
            } else {
                this.ira_isDisabledAmphur = 1;
                this.ira_selectedAmphur = null;
            }
        },

        async ira_selectedAmphur(val) {
            if (val != null) {
                this.ira_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.ira_selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
            } else {
                this.ira_isDisabledTambon = 1;
                this.ira_selectedTambon = null;
            }
        },

        ira_selectedDisaster(val) {
            if (val != null) {
                this.error_ira_selectedDisaster = false;
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.riskArea_Table = [];
            } else {
                this.riskArea_Table = this.cloneTable;
            }
        },

        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        }

        // check_duplicate(val) {
        //   if (val == "duplicate riskarea") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลพื้นที่เสี่ยงภัยไม่สำเร็จ",
        //     //   detail: "มีข้อมูลพื้นที่เสี่ยงภัยนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลพื้นที่เสี่ยงภัยไม่สำเร็จ",
        //           text: "มีข้อมูลพื้นที่เสี่ยงภัยนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลพื้นที่เสี่ยงภัย",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลพื้นที่เสี่ยงภัย",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedRiskArea.map((item) => ({
                    riskarea_id: item.riskarea_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/riskarea?user=${userId}`, {
                    body: {
                        topic: 'edit-riskarea_date_multiple',
                        selectedRiskArea: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.riskAreaModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลพื้นที่เสี่ยงภัยจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchRiskArea();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedRiskArea = [...this.riskArea_Table];
            } else {
                this.selectedRiskArea = [];
            }
            this.$emit('selectedRiskArea', this.selectedRiskArea);
            // console.log('selectedRiskArea', this.selectedRiskArea);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedRiskArea.some((item) => item.riskarea_id === row.riskarea_id)) {
                    this.selectedRiskArea.push(row);
                }
            } else {
                this.selectedRiskArea = this.selectedRiskArea.filter((item) => item.riskarea_id !== row.riskarea_id);
            }
            this.$emit('selectedRiskArea', this.selectedRiskArea);
            // console.log('selectedRiskArea', this.selectedRiskArea);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchRiskArea();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_7') &&
                    !this.isFocused('TextBox_8') &&
                    !this.isFocused('TextBox_9')
                ) {
                    this.saveData();
                }
            }
        },

        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: { topic: 'get-level-option' }
                })
                .then((response) => {
                    (this.riskLevelOptions = response.data.data),
                        this.riskLevelOptions.splice(0, 0, {
                            risklevel_number: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '' && this.riskArea_Table !== []) {
                    this.riskArea_Table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_riskarea_name ? item.riskarea_name.includes(this.filter) : '') ||
                            (this.columns_organize_name ? item.organize_name.includes(this.filter) : '') ||
                            (this.columns_system_name ? item.system_name.includes(this.filter) : '') ||
                            (this.columns_disaster_level ? item.disaster_level.includes(this.filter) : '') ||
                            (this.columns_riskarea_location ? item.riskarea_location.includes(this.filter) : '') ||
                            (this.columns_riskarea_lat ? item.riskarea_lat.includes(this.filter) : '') ||
                            (this.columns_riskarea_lon ? item.riskarea_lon.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.riskArea_Table.length; i++) {
                        this.riskArea_Table[i]['index'] = i + 1;
                    }
                } else {
                    this.riskArea_Table = [...this.cloneTable];
                    for (let i = 0; i < this.riskArea_Table.length; i++) {
                        this.riskArea_Table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },

        // Doe ค้นหา  3/6 จบ

        async initialData() {
            const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/riskarea`, {
                    body: {
                        topic: 'get-table',
                        userOrg,
                        isDistrict
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.riskArea_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    for (let i = 0; i < this.riskArea_Table.length; i++) {
                        this.riskArea_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.riskArea_Table == id  ",this.riskArea_Table)

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.riskArea_Table);
                    // Doe ช่องว่างใส่ ขีด
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.riskArea_Table = this.cloneTable;
            } else {
                this.riskArea_Table = [];
            }

            await this.axios
                .post(`${this.$url_service}/initial/risklevel`, {
                    body: { topic: 'get-level-option' }
                })
                .then((response) => {
                    (this.riskLevelOptions = response.data.data),
                        this.riskLevelOptions.splice(0, 0, {
                            risklevel_number: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: {
                        topic: 'get-province'
                    }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });

            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].disaster_level == null || data[index].disaster_level == 'null' || data[index].disaster_level == '') {
                    data[index].disaster_level = '-';
                }
                if (data[index].riskarea_location == null || data[index].riskarea_location == 'null' || data[index].riskarea_location == '') {
                    data[index].riskarea_location = '-';
                }
                if (data[index].riskarea_lat == null || data[index].riskarea_lat == 'null' || data[index].riskarea_lat == '') {
                    data[index].riskarea_lat = '-';
                    data[index]['riskarea_latPDF'] = '-';
                } else if (data.riskarea_lat !== '-') {
                    data[index]['riskarea_latPDF'] = parseFloat(data[index].riskarea_lat).toFixed(6);
                }
                if (data[index].riskarea_lon == null || data[index].riskarea_lon == 'null' || data[index].riskarea_lon == '') {
                    data[index].riskarea_lon = '-';
                    data[index]['riskarea_lonPDF'] = '-';
                } else if (data[index].riskarea_lon !== '-') {
                    data[index]['riskarea_lonPDF'] = parseFloat(data[index].riskarea_lon).toFixed(6);
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.riskAreaModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.ira_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.ira_selectedTambon = null;
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.riskAreaModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.ira_selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchRiskArea() {
            if (!this.checkToken()) {
                return;
            }

            const userId = this.getUsername();

            // console.log('this.checkToken() = ', this.checkToken());

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.equipment_name', this.equipment_name);
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            // console.log('this.getUserOrganize()', this.getUserOrganize());
            // console.log('this.checkPermission()', this.checkPermission());
            // console.log("this.organize_table",this.organize_table)

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
            await this.axios
                .post(`${this.$url_service}/initial/riskarea`, {
                    body: {
                        topic: 'search-table',
                        name: this.location_name,
                        disaster: this.disasterSelect,
                        //  this.checkPermission() ==  true ให้ใช้ค่า  this.selectedOrganize ex. { id: 'or-000075', name: 'กองปฏิบัติการดับเพลิงและกู้ภัย 6' }
                        //  this.checkPermission() ==  false ให้ใช้ค่า  this.getUserOrganize() ex. or-000075
                        // organize: this.checkPermission() ? userSelectedOrganize : this.getUserOrganize(),
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        level: this.riskLevelSelected,
                        // organize: userSelectedOrganize, // เช็คหน่วยงานหลัก
                        organize: this.organize_table,
                        userOrg,
                        isDistrict
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    this.riskArea_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6

                    for (let i = 0; i < this.riskArea_Table.length; i++) {
                        this.riskArea_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.riskArea_Table == id  ",this.riskArea_Table)

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.riskArea_Table);
                    // Doe ช่องว่างใส่ ขีด

                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ
            if (this.columns_disabled == true) {
                this.riskArea_Table = this.cloneTable;
            } else {
                this.riskArea_Table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.location_name !== '' ||
                this.disasterSelect !== null ||
                this.riskLevelSelected !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];

                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อพื้นที่' && this.location_name !== '') {
                        element.textShow = this.location_name;
                    }
                    if (element.DataName === 'ประเภทสาธารณภัย' && this.disasterSelect !== null) {
                        element.textShow = this.disasterSelect.system_name;
                    }
                    if (element.DataName === 'ระดับ' && this.riskLevelSelected !== null) {
                        element.textShow = this.riskLevelSelected.risklevel_number;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }
                }

                this.text_Footer = true;
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        addDisaster() {
            if (this.ira_selectedDisaster == null) {
                this.error_ira_selectedDisaster = true;
            } else {
                for (let i = 0; i < this.ira_selectedDisaster.length; i++) {
                    this.disaster_table.push(this.ira_selectedDisaster[i]);
                }
            }
        },

        async inputMap_latlon() {
            if (this.ira_lat !== '' && this.ira_lat !== null && this.ira_lon !== '' && this.ira_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.ira_lat}/lon=${this.ira_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.ira_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.ira_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.ira_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.ira_selectedProvince = null;
                                this.ira_selectedAmphur = null;
                                this.ira_selectedTambon = null;
                            }

                            // console.log("this.ira_selectedProvince",this.ira_selectedProvince)
                            // console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
                            // console.log("this.ira_selectedTambon",this.ira_selectedTambon)
                        } else {
                            this.ira_selectedProvince = null;
                            this.ira_selectedAmphur = null;
                            this.ira_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.ira_selectedProvince = null;
                this.ira_selectedAmphur = null;
                this.ira_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.ira_selectedProvince",this.ira_selectedProvince)
            //   console.log("this.ira_selectedAmphur",this.ira_selectedAmphur)
            //   console.log("this.ira_selectedTambon",this.ira_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.ira_selectedProvince) {
                this.sP.push(this.ira_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.ira_selectedAmphur) {
                this.sA.push(this.ira_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.ira_selectedProvince == null) {
                this.ira_lat = '';
                this.ira_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.ira_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ira_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ira_lat = lat;
                        this.ira_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.ira_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.ira_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ira_lat = lat;
                        this.ira_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.ira_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.ira_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.ira_lat = lat;
                        this.ira_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.ira_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.ira_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ira_lat = lat;
                            this.ira_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ira_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.ira_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ira_lat = lat;
                            this.ira_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.ira_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.ira_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.ira_lat = lat;
                            this.ira_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.ira_lat = '';
                    this.ira_lon = '';
                }
            }
        },

        selectMap_passValue(variable) {
            // this.displayMap = false;
            // console.log(variable);
            this.ira_lat = variable.lat;
            this.ira_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.ira_lat",this.ira_lat)
            // console.log("this.ira_lon",this.ira_lon)
            if (this.ira_lat !== null && this.ira_lon !== null && this.ira_lat !== '' && this.ira_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            if (this.deleteTable == 'organize') {
                if (this.deleteTable == 'organize') {
                    this.displayConfirmation = false;
                    this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
                }
            } else {
                const userId = this.getUsername();
                this.displayConfirmation = false;
                await this.axios
                    .post(`${this.$url_service}/initial/riskarea?user=${userId}`, {
                        body: {
                            topic: 'delete-risk-area',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchRiskArea()
                    );
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลพื้นที่เสี่ยงภัย",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลพื้นที่เสี่ยงภัย',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            const userId = this.getUsername();
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            // console.log('this.checkToken() = ', this.checkToken());

            //Check null value
            if (
                this.ira_location_name == '' ||
                this.ira_selectedOrganize.name == undefined ||
                this.ira_disasterTypeSelected == null ||
                this.ira_selectedProvince == null ||
                this.ira_selectedAmphur == null ||
                this.ira_selectedTambon == null
            ) {
                if (this.ira_location_name == '') {
                    this.error_ira_location_name = true;
                }
                if (this.ira_selectedOrganize.name == undefined) {
                    this.error_ira_selectedOrganize = true;
                }
                if (this.ira_disasterTypeSelected == null) {
                    this.error_ira_selectedDisaster = true;
                }
                if (this.ira_selectedProvince == null) {
                    this.error_ira_selectedProvince = true;
                }
                if (this.ira_selectedAmphur == null) {
                    this.error_ira_selectedAmphur = true;
                }
                if (this.ira_selectedTambon == null) {
                    this.error_ira_selectedTambon = true;
                }
            } else {
                if (this.selectedData == '') {
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    await this.axios
                        .post(`${this.$url_service}/initial/riskarea?user=${userId}`, {
                            body: {
                                topic: 'add-risk-area',
                                userOrg,
                                name: this.ira_location_name,
                                organize: this.ira_selectedOrganize.id,
                                location: this.ira_location_detail,
                                location_id: this.ira_selectedTambon,
                                disaster_type: this.ira_disasterTypeSelected.system_id,
                                level: this.ira_riskLevelSelected,
                                lat: this.ira_lat,
                                lon: this.ira_lon
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // (this.initialData());
                                this.searchRiskArea();
                            // โหลดเพิ่มแก้ไข 5/8
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 5/8 จบ
                            // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                            // console.log("this.check_duplicate ",this.check_duplicate)
                            if (this.check_duplicate == 'duplicate riskarea') {
                                this.$fire({
                                    type: 'error',
                                    title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                    text: 'มีข้อมูลนี้ในระบบแล้ว',
                                    timer: 3000,
                                    confirmButtonColor: '#d33'
                                });
                            } else {
                                this.$fire({
                                    title: 'เพิ่มข้อมูลสำเร็จ',
                                    text: 'ข้อมูลพื้นที่เสี่ยงภัย',
                                    type: 'success',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                            }
                        });
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.riskAreaModal = false;
                    // this.$fire({
                    //     type: "success",
                    //     title:"เพิ่มข้อมูลสำเร็จ",
                    //     text: "ข้อมูลพื้นที่เสี่ยงภัย",
                    //     timer: 3000,
                    //     confirmButtonColor: '#28B463',
                    //   });
                } else {
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ

                    await this.axios
                        .post(`${this.$url_service}/initial/riskarea?user=${userId}`, {
                            body: {
                                topic: 'edit-risk-area',
                                id: this.temp,
                                name: this.ira_location_name,
                                organize: this.ira_selectedOrganize.id,
                                location: this.ira_location_detail,
                                location_id: this.ira_selectedTambon,
                                disaster_type: this.ira_disasterTypeSelected.system_id,
                                level: this.ira_riskLevelSelected,
                                lat: this.ira_lat,
                                lon: this.ira_lon
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchRiskArea()
                        );
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "แก้ไขข้อมูลสำเร็จ",
                    //   detail: "ข้อมูลพื้นที่เสี่ยงภัย",
                    //   life: 3000,
                    // });
                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: 'ข้อมูลพื้นที่เสี่ยงภัย',
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    // console.log("Edit data");
                    this.riskAreaModal = false;
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('ira_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/riskarea`, {
                    body: {
                        topic: 'showone-risk-area',
                        id: data
                    }
                })
                .then((response) => {
                    (this.selectedData = response.data.data),
                        // (console.log("this.selectedData",this.selectedData)),
                        (this.ira_location_name = response.data.data.riskarea_name),
                        (this.ira_selectedOrganize = {
                            id: response.data.data.riskarea_organize,
                            name: response.data.data.organize_name
                        }),
                        (this.ira_location_detail = response.data.data.riskarea_location),
                        (this.ira_disasterTypeSelected = {
                            system_id: response.data.data.disaster_id,
                            system_name: response.data.data.system_name
                        }),
                        (this.ira_lat = response.data.data.riskarea_lat),
                        (this.ira_lon = response.data.data.riskarea_lon);

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);

                    if (this.ira_lat !== '' && this.ira_lat !== null && this.ira_lon !== '' && this.ira_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('ira_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.selectedData = '';
                this.riskAreaModal = false;
                this.setDefault();
                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.ira_location_name = '';
            this.ira_selectedOrganize = {};
            this.ira_location_detail = '';
            this.ira_selectedProvince = null;
            this.ira_disasterTypeSelected = null;
            this.ira_riskLevelSelected = null;
            this.ira_lat = '';
            this.ira_lon = '';
            this.error_ira_location_name = false;
            this.error_ira_selectedOrganize = false;
            this.error_ira_selectedDisaster = false;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.error_ira_selectedProvince = false;
            this.error_ira_selectedAmphur = false;
            this.error_ira_selectedTambon = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        async clearSearchField() {
            this.location_name = '';
            this.disasterSelect = null;
            this.selectedOrganize = {};
            this.selectedProvince = null;
            this.riskLevelSelected = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.organize_table = [];
            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.location_name = '';
                this.disasterSelect = null;
                this.selectedOrganize = {};
                this.selectedProvince = null;
                this.riskLevelSelected = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.organize_table = [];
                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(ira_lat, ira_lon) {
            let lat = ira_lat;
            let lon = ira_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province) {
            if (tambon) {
                this.PAT = tambon;
                // console.log("this.PAT=tambon",this.PAT)
            } else if (amphur) {
                this.PAT = amphur;
                // console.log("amphur",amphur)
            } else if (province) {
                this.PAT = province;
                // console.log("province",province)
            } else {
                this.PAT = {};
                // console.log("this.PAT={}",this.PAT)
            }
        },
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.ira_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.ira_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.ira_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.ira_selectedProvince = null;
                this.ira_selectedAmphur = null;
                this.ira_selectedTambon = null;
            }
        },
        // Doe :   เพิ่ม มุดmap 4/4 จบ
        alertDisplay(temp) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 11;
                this.PDF_FontBodyVer = 8;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    disaster_level: { cellWidth: 40 },
                    organize_name: { cellWidth: 100 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    disaster_level: { cellWidth: 40 },
                    organize_name: { cellWidth: 120 }
                };
            } else {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 11;
                this.PDF_FontBodyVer = 8;

                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 10;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_riskarea_name = false;
                this.columns_organize_name = false;
                this.columns_system_name = false;
                this.columns_disaster_level = false;
                this.columns_riskarea_location = false;
                this.columns_riskarea_lat = false;
                this.columns_riskarea_lon = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;

                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'riskarea_name') {
                        this.columns_riskarea_name = true;
                    } else if (!getData.includes('riskarea_name')) {
                        this.columns_riskarea_name = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'system_name') {
                        this.columns_system_name = true;
                    } else if (!getData.includes('system_name')) {
                        this.columns_system_name = false;
                    }

                    if (element == 'disaster_level') {
                        this.columns_disaster_level = true;
                    } else if (!getData.includes('disaster_level')) {
                        this.columns_disaster_level = false;
                    }

                    if (element == 'riskarea_location') {
                        this.columns_riskarea_location = true;
                    } else if (!getData.includes('riskarea_location')) {
                        this.columns_riskarea_location = false;
                    }

                    if (element == 'riskarea_latPDF') {
                        this.columns_riskarea_lat = true;
                    } else if (!getData.includes('riskarea_latPDF')) {
                        this.columns_riskarea_lat = false;
                    }

                    if (element == 'riskarea_lonPDF') {
                        this.columns_riskarea_lon = true;
                    } else if (!getData.includes('riskarea_lonPDF')) {
                        this.columns_riskarea_lon = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
.table_row {
    text-align: center;
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
        .p-dialog-content {
            overflow-y: auto;
        }
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
